import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { JobsService } from '../../../pages/pages/jobs/jobs.service';
import { v4 as uuidv4 } from 'uuid';
@Component({
  selector: 'gtapp-user-lookup',
  standalone: false,
  templateUrl: './user-lookup.component.html',
  styleUrl: './user-lookup.component.scss',
})
export class UserLookupComponent implements OnInit {
  userLookupDataList: any = [];
  userLookupDataListBackup: any = [];

  userLookupFieldId = uuidv4();

  @Input() selectedUser: any = {};

  @Output() onSelectUserEvent = new EventEmitter();

  constructor(private jobService: JobsService) {}
  ngOnInit(): void {
    this.onSearchUsers('');
  }
  searchUsers(event: any) {
    const searchStr = event?.target?.value || '';

    if (searchStr?.length < 2) return;
    this.onSearchUsers(searchStr);
  }
  onSearchUsers(searchStr?: any) {
    this.jobService
      .getUserList({
        search_str: searchStr || '',
      })
      .subscribe((response: any) => {
        if (response['status'] == 'success') {
          this.userLookupDataList = response.data || [];
          if (!searchStr)
            this.userLookupDataListBackup = JSON.parse(
              JSON.stringify(this.userLookupDataList),
            );
        }
      });
  }
  onSelectUser(userData: any) {
    this.selectedUser = userData;
    this.onSelectUserEvent.emit(userData);
  }

  shiftFocus(elementId: string) {
    setTimeout(() => {
      var element = <HTMLInputElement>document.getElementById(elementId);
      element?.focus();
    }, 200);
  }
  inputFocused() {
    this.selectedUser = {};

    this.userLookupDataList = [];
    setTimeout(() => {
      this.userLookupDataList = JSON.parse(
        JSON.stringify(this.userLookupDataListBackup || []),
      );
    }, 200);
  }
}
